import React, { useState, useEffect, useCallback } from 'react';
import 'devextreme/data/odata/store';
import UserService from "../../api/user.service";
import DataGrid, {
  Column,
  Paging,
  FilterRow,
  Editing,
  Texts,
  Button,
  Form,
  HeaderFilter,
  SearchPanel,
  RequiredRule,
  StringLengthRule,
  Popup,
  EmailRule,
  FilterPanel
} from 'devextreme-react/data-grid';
import { Item, PatternRule } from 'devextreme-react/form';
import TenantService from "../../api/tenant.service";
import { useRef } from 'react';
import Toast from 'components/Toast';
import {LoadPanel as LoadingPanel} from 'devextreme-react/load-panel';
import {Tooltip} from 'devextreme-react';
import SlidingDrawer from 'components/sliding-drawer/SlidingDrawer';
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import {
  Form as DxForm,
  SimpleItem,
  GroupItem,
  Label,
  RequiredRule as DxFormRequiredRules,
  EmailRule as DxEmailRule,
  StringLengthRule as DXStringLengthRule
} from 'devextreme-react/form';

export default function UserPage() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false);
  const [loadingText, setloadingText] = useState('Loading...');
  const [editFlag, setEditFlag] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const formRef = useRef();
  const dxFormRef = useRef();
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000
  });
  const tenant = TenantService.getTenant()
  const dropDataGridRef = useRef();
  const [isDisabled, setIsDisabled] = useState(true)
  const [formData, setFormData] = useState({
    id: null,
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    role: "",
    password: ""
  });
  const [prevData, setPrevData] = useState(null)

  useEffect(() => {
    getData()
  }, []);

  //To get tenant user list
  function getData() {
    UserService.getListTenantUsers(tenant).then((value) => {
      let response = value.data
      setData(response.data)
    })
  }

  //While adding new tenant user
  function onRowInserted(e) {
    setLoading(true); // Start loader
    let roleId = types.find((type) => type.name === e.data.role.name);
    UserService.createTenantUser(e.data.email, e.data.firstName, e.data.lastName, roleId.id, e.data.password, e.data.mobileNumber).then((response) => {
      if (response.status === 422 || response.data.status === 422){
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'error',
          status: 422,
          message: response.data.message,
        });
      } else {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'success',
          status: 200,
          message: response.data.message,
        });
      }
      getData()
    })
    .catch((er) =>{
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        status: 500,
        type: 'error',
        message: 'Something went wrong. Please try again later.',
      });
    }).finally(() => {
      setLoading(false); // Stop loader after response (success or error)
    });
  }

  //while deleting the tenant user
  function onRowRemoved(e) {
    setLoading(true); // Start loader
    UserService.removeTenantUser(e.data.id).then((tenantUser) => {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: tenantUser.status===200 ? 'success' : 'error', 
        status: tenantUser?.data?.status ? tenantUser?.data?.status : tenantUser.status,
        message: tenantUser?.data?.message ? tenantUser.data.message : tenantUser.message,
      });
      getData()
    }).catch((er) =>{
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        status: 500,
        type: 'error',
        message: 'Something went wrong. Please try again later.',
      });
      getData()
    }).finally(() => {
      setLoading(false); // Stop loader after response (success or error)
    });
  }

  //While editing the existing tenant user
  function onRowUpdating(e) {
    let roleId
    const id = e.oldData.id
    if (e.newData && e.newData.role && e.newData.role.name){
      roleId = types.find((type) => type.name === e.newData.role.name);
    }
    let role = e.newData.role !== undefined ? roleId.id : e.oldData.role.id
    let firstName = e.newData.firstName !== undefined ? e.newData.firstName : e.oldData.firstName
    let lastName = e.newData.lastName !== undefined ? e.newData.lastName : e.oldData.lastName
    let email = e.newData.email !== undefined ? e.newData.email : e.oldData.email
    let mobileNumber = e.newData.mobileNumber !== undefined ? e.newData.mobileNumber : e.oldData.mobileNumber
    UserService.editTenantUser(email, firstName, lastName, id, role, mobileNumber).then((response) => {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: 'success',
        status: 200,
        message: response.data.message,
      });
      getData()
    })
  }

  //To customize the cell params
  function buttonColor(e) {
    if ((e.column.dataField === 'email') && e.rowType !== "header") {
      e.cellElement.style.color = "#337ab7";
      e.cellElement.style.setProperty('cursor', 'pointer', 'important')
      e.cellElement.style.setProperty('text-decoration', 'underline')
    }
  }

  //It is triggered onclick of row level edit button
  function onEditClick(e) {
    setEditFlag(true)
  }

  //It is triggered onclick of cancel button in popup while adding and editing
  function onEditCancel(e) {
    setEditFlag(false)
  }

  //It is triggered onclick of save button in popup while adding and editing
  function onSaved(e) {
    setEditFlag(false)
  }

  function handleCloseDrawer(){
    setEditingRow(null)
    setFormData({
      id: null,
      firstName: "",
      lastName: "",
      email: "",
      mobileNumber: "",
      role: "",
      password: ""
    })
    setPrevData(null)
    setIsOpen(false)
  }

  function onAddRow() {
    setLoading(true); // Start loader
    const { firstName, lastName, email, mobileNumber, role, password} = formData
    let roleId = types.find((type) => type.id === role);
    UserService.createTenantUser(email, firstName, lastName, roleId.id, password, mobileNumber).then((response) => {
      if (response.status === 422 || response.data.status === 422){
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'error',
          status: 422,
          message: response.data.message,
        });
      } else {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'success',
          status: 200,
          message: response.data.message,
        });
      }
      getData()
    })
    .catch((er) =>{
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        status: 500,
        type: 'error',
        message: 'Something went wrong. Please try again later.',
      });
    }).finally(() => {
      setLoading(false); // Stop loader after response (success or error)
    });
  }

  function onRowUpdate(e) {
    const { id, firstName, lastName, email, mobileNumber, role, password} = formData
    let roleId
    if (role){
      roleId = types.find((type) => type.id === role);
    }
    let updatedRole = role !== undefined ? roleId.id : role
    UserService.editTenantUser(email, firstName, lastName, id, updatedRole, mobileNumber).then((response) => {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: 'success',
        status: 200,
        message: response.data.message,
      });
      getData()
    })
  }

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const result = dxFormRef.current?.validate?.();
    if (result?.isValid) {
      if(formData && formData?.id){
        onRowUpdate()
      }else{
        onAddRow()
      }
      handleCloseDrawer();
    }
  },[formData, handleCloseDrawer]);

  function handleSave(){
    formRef.current?.requestSubmit();
  }

  function onSubmit(data){
    console.log("edited:", editingRow)
    setEditingRow(null)
    setIsOpen(false)
  }

  function handleInputChange(e, name) {
    // const value = name === "name" ? e?.value : e?.selectedItem;
    const value = name === "role" ? e?.selectedItem : e?.value;
    if (!value) return;
    setEditingRow(prev => ({
      ...prev,
      [name]: value
    }));
  }

  function editRow(e) {
    setEditingRow(e.row?.data)
    setFormData({
      id: e.row?.data?.id,
      firstName: e.row?.data?.firstName,
      lastName: e.row?.data?.lastName,
      email: e.row?.data?.email,
      mobileNumber: e.row?.data?.mobileNumber,
      role: e.row?.data?.role?.id,
      password: e.row?.data?.password
    })
    setPrevData({
      id: e.row?.data?.id,
      firstName: e.row?.data?.firstName,
      lastName: e.row?.data?.lastName,
      email: e.row?.data?.email,
      mobileNumber: e.row?.data?.mobileNumber,
      role: e.row?.data?.role?.id,
      password: e.row?.data?.password
    })
    setIsOpen(true)
  }

  
  let types = [{ id: 1, name: "Admin" }, { id: 2, name: "Viewer" }]
  const UserEditorOptions = {
    items: types,
    searchEnabled: true,
    // defaultValue: userRoleId,
    displayExpr: "name",
    valueExpr: "name",
    placeholder: "Select Role"
  };

  // const clearFilters = () => {
  //   const dataGridInstance = dropDataGridRef.current.instance;
  //   dataGridInstance.clearFilter();
  //   setIsDisabled(true)
  // }

  // const optionChange = (e) => {
  //   if (e.fullName.indexOf("filterValue") !== -1 || e.fullName.indexOf("searchPanel") !== -1) {
  //     if (e.value === null){
  //       const dataGridInstance = dropDataGridRef.current.instance;
  //       dataGridInstance.clearFilter();
  //       setIsDisabled(true)
  //     } else {
  //       setIsDisabled(false)
  //     }
  //   }
  // }

  return (
    <>
    <div className='headerHeadingPage'>
		  <div className='pageFullWidthEvents'>
        <h5 className='marginZeroEvents'>
          <b>User Config</b>
        </h5>
      <DataGrid
        // onOptionChanged={optionChange}
        ref={dropDataGridRef}
        showColumnLines={false}
        showRowLines={true}
        onEditingStart={onEditClick}
        onRowInserted={onRowInserted}
        onRowRemoved={onRowRemoved}
        onSaved={onSaved}
        onRowUpdating={onRowUpdating}
        // onCellPrepared={buttonColor}
        allowColumnResizing={true}
        onEditCanceling={onEditCancel}
        height={'calc(100vh - 102px)'}
        noDataText={loadingText}
        onColumnsChanging={function (e) {
          if(e.component?.getDataSource()?._totalCount <= 0 && data.length > 0){
            setloadingText('No Data');
          }
        }}
        onToolbarPreparing={(e) => {
          e.toolbarOptions.items = e.toolbarOptions.items.filter(
            (item) => item.name !== 'addRowButton'
          );
        
          e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: '',
              text: '',
              stylingMode: 'text',
              // onClick: () => e.component.addRow(),
              onClick: () => setIsOpen(true),
              elementAttr: {
                id: 'addTenantButton',
              },
              template: (buttonData, buttonElement) => {
                const container = document.createElement('div');
                container.style.display = 'flex';
                container.style.alignItems = 'center';
                container.style.justifyContent = 'center';
              
                container.innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" 
                       viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" 
                       stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                `;
              
                buttonElement.appendChild(container);
              }
              
            },
          });
        }}
        dataSource={data}>
        <Paging enabled={false} />
        <Editing
          allowUpdating={true}
          allowDeleting={true}
          allowAdding={true}
          use-icons={true}
          mode="popup"
          // texts={{
          //   addRow: 'Add a User',
          // }}
        >
          <Texts
            //confirmDeleteMessage={`Are you sure you want to delete this ${email}?`}
            confirmDeleteMessage="Are you sure you want to delete this user"
          />
          {/* <Popup
            showTitle={true}
            width={500}
            height={800}
            title={editFlag ? "Edit User" : "Add User"}
            dicks={false}
          /> */}
          <Form colCount={1}>
            <Item dataField="firstName" />
            <Item dataField="lastName" />
            <Item dataField="email" />
            <Item
              dataField="mobileNumber"
              helpText="Please provide a phone number that begins with a plus sign and includes the corresponding country code."
            />
            <Item dataField="role.name"
              editorType="dxSelectBox"
              editorOptions={UserEditorOptions}>
            </Item>
            <Item dataField="password" visible={editFlag ? false : true} />
          </Form>
        </Editing>
        <FilterRow visible="true" apply-filter="true" />
        <HeaderFilter visible="showHeaderFilter" />
        <SearchPanel visible="true" width="240" placeholder="Search..." />
        <FilterPanel visible={true} texts={{createFilter: '', clearFilter:'Clear Filter', filterEnabledHint: ''}}/>
        <Column
          dataField={'firstName'}
          caption={"First Name"}
          width={100}
          hidingPriority={8}
        >
          <RequiredRule />
        </Column>
        <Column
          dataField={'lastName'}
          caption={"Last Name"}
          width={200}
          hidingPriority={8}
        >
          <RequiredRule />
        </Column>
        <Column
          dataField={`email`}
          caption={"Email"}
          width={300}
          hidingPriority={8}
        >
          <RequiredRule />
          <EmailRule />
        </Column>
        <Column
          dataField={`mobileNumber`}
          caption={"Mobile Number"}
          width={300}
          hidingPriority={8}
        >
          <RequiredRule />
          <PatternRule
            pattern={/^\+(?:[0-9] ?){6,14}[0-9]$/}
            message={'Your phone must have "+11234567890" format!'}
          />
        </Column>
        <Column
          dataField={'role.name'}
          caption={"Role"}
          width={80}
          hidingPriority={8}
          dataType="string"
        >
          <RequiredRule />
        </Column>
        <Column dataField='password'
          visible={false} >
          <RequiredRule message="Password is required" />
          <StringLengthRule 
            min={8} 
            max={20} 
            message="Password must be between 8 and 20 characters long" 
          />
          <PatternRule
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
            message="Minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
          />
        </Column>
        <Column
          dataField={'type'}
          caption={''}
          allowSorting={false}
          allowFiltering={false}
        >
        </Column>

        <Column type="buttons" width={110} >
          <Button name="edit" onClick={editRow}/>
          <Button name="delete" />
        </Column>
      </DataGrid>
      <Tooltip
        target="#addTenantButton"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        position="bottom"
      >
        <div className="custom-tooltip">Add a User</div>
      </Tooltip>
      <LoadingPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={loading}
        showIndicator={true}
        showPane={true}
        shading={true}
        closeOnOutsideClick={false}
      />
      {/* <div className='uploadBtnAssetsReport clrConfig'>
        <ReactButton
          disabled={isDisabled}
          width={"160px"}
          height={"90%"}
          style={{marginTop: "5px"}}
          type="normal"
          stylingMode="outlined"
          onClick={clearFilters}
          text="Clear Filters"
        />
      </div> */}
      <Toast
        setParentToastConfig={setToastConfig}
        toastBody={toastConfig}
      />
    </div>
    </div>

    <SlidingDrawer 
      title={`${formData?.id ? "Edit" : "Add"} User`}
      isOpen={isOpen} 
      onClose={handleCloseDrawer}
      handleSave={handleSave}
      formData={formData}
      prevData={prevData} 
    >
      {isOpen &&
      <form ref={formRef} autoComplete="off" onSubmit={handleSubmit}>
        <div>
          <DxForm
            formData={formData}
            onFieldDataChanged={(e) => {
              setFormData((prev) => ({
                ...prev,
                [e.dataField]: e.value,
              }));
            }}
            onInitialized={(e) => {
              dxFormRef.current = e.component;
            }}
            labelLocation="top"
            showColonAfterLabel={false}
            showValidationSummary={false}
          >
            <GroupItem colCount={1}>
              <SimpleItem
                dataField="firstName"
                editorType="dxTextBox"
                editorOptions={{
                  valueChangeEvent: 'input',
                }}
                validationRules={[{ type: 'required', message: 'First Name is required' }]}
              >
                <Label text="First Name" isRequired />
              </SimpleItem>

              <SimpleItem
                dataField="lastName"
                editorType="dxTextBox"
                editorOptions={{
                  valueChangeEvent: 'input',
                }}
                validationRules={[{ type: 'required', message: 'Last Name is required' }]}
              >
                <Label text="Last Name" isRequired />
              </SimpleItem>

              <SimpleItem
                dataField="email"
                editorType="dxTextBox"
                editorOptions={{
                  mode: 'email',
                  name: 'fake_email_field',
                  autoComplete: 'off',
                  valueChangeEvent: 'input',
                }}
              >
                <Label text="Email" isRequired />
                <DxFormRequiredRules message="Email is required" />
                <DxEmailRule message="Invalid email format" />
              </SimpleItem>

              <SimpleItem
                dataField="mobileNumber"
                editorType="dxTextBox"
                editorOptions={{
                  mode: 'tel',
                  valueChangeEvent: 'input'
                }}
                helpText="Please provide a phone number that begins with a plus sign and includes the corresponding country code."
              >
                <Label text="Mobile Number" />
                <DxFormRequiredRules message="Mobile Number is required" />
                <PatternRule
                  pattern={/^\+(?:[0-9] ?){6,14}[0-9]$/}
                  message='Your phone must have "+11234567890" format!'
                />
              </SimpleItem>

              <SimpleItem
                dataField="role"
                editorType="dxSelectBox"
                editorOptions={{
                  items: UserEditorOptions?.items || [],
                  displayExpr: 'name',
                  valueExpr: 'id',
                  placeholder: 'Select...',
                  // showClearButton: true,
                  searchEnabled: true,
                  dropDownOptions: {
                    container: '.slide-pane'
                  },
                  itemRender: (item) => (
                    <div className="custom-item">
                      <div className="product-name">{item.name}</div>
                    </div>
                  ),
                }}
                validationRules={[{ type: 'required', message: 'Role is required' }]}
              >
                <Label text="Role" isRequired />
              </SimpleItem>

              {!formData.id &&
                <SimpleItem
                  dataField="password"
                  editorType="dxTextBox"
                  editorOptions={{ mode: 'password', valueChangeEvent: 'input', }}
                >
                  <Label text="Password" isRequired />
                  <DxFormRequiredRules message="Password is required" />
                  <DXStringLengthRule
                    min={8}
                    max={20}
                    message="Password must be between 8 and 20 characters long"
                  />
                  <PatternRule
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                    message="Minimum 8 characters, with at least 1 uppercase, 1 lowercase, 1 number, and 1 special character"
                  />
                </SimpleItem>
              }

            </GroupItem>
          </DxForm>
        </div>
      </form>
      }
    </SlidingDrawer>
    </>
  );
}
